export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        query_time: '查询时间',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        failure_parts: '故障件名称',
        total_of_failure_parts: '故障件数量',
        of_organization: '组织占比',
        of_total: '全量占比',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        query_time: 'Query time',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Total cases',
        failure_parts: 'Failure parts',
        total_of_failure_parts: 'Total of failure parts',
        of_organization: '% of Organization',
        of_total: '% of Total',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        query_time: 'Abfragezeit',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        failure_parts: 'Defekte Teile',
        total_of_failure_parts: 'Anzahl der defekten Teile',
        of_organization: '% der Organisation',
        of_total: '% vom Gesamtwert',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        reporting_organization_name: 'Nom de l\'organisation de rapport',
        full_query: 'Requête complète',
        query_time: 'Temps de requête',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        number_of_cases: 'Total cas',
        failure_parts: 'Pièces défectueuses',
        total_of_failure_parts: 'Total pièces défectueuses',
        of_organization: '% de l\'oganisation',
        of_total: '% du total',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        query_time: 'Tempo di Query',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        failure_parts: 'Nome Pezzi Guasti',
        total_of_failure_parts: 'Numero Totale di Pezzi Guasti',
        of_organization: 'Percentuale per Organizzazione',
        of_total: 'Percentuale Totale',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        reporting_organization_name: 'Rapporterende organisatienaam',
        full_query: 'Volledige query',
        query_time: 'Query time',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        failure_parts: 'Falende onderdelen',
        total_of_failure_parts: 'Totaal van falende onderdelen',
        of_organization: '% van organisatie',
        of_total: '% van totaal',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        query_time: 'Thời gian truy vấn',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Tổng số trường hợp',
        failure_parts: 'Phụ tùng bị lỗi',
        total_of_failure_parts: 'Tổng số phụ tùng bị lỗi',
        of_organization: 'Phần trăm của tổ chức',
        of_total: 'Phần trăm của tổng số',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        reporting_organization_name: 'Nombre de la organización de informes',
        full_query: 'Consulta completa',
        query_time: 'Tiempo de consulta',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        failure_parts: 'Nombre de la pieza defectuosa',
        total_of_failure_parts: 'Cantidad de piezas defectuosas',
        of_organization: 'Porcentaje de la organización',
        of_total: 'Porcentaje completo',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização de relatório',
        full_query: 'Consulta completa',
        query_time: 'Tempo de consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Total de casos',
        failure_parts: 'Nome das peças com defeito',
        total_of_failure_parts: 'Total de peças com defeito',
        of_organization: 'Porcentagem da organização',
        of_total: 'Porcentagem total',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        query_time: 'Data zapytania',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        failure_parts: 'Uszkodzona część',
        total_of_failure_parts: 'Liczba uszkodzonych części',
        of_organization: '% organizacji',
        of_total: '% ogółu',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        query_time: 'Sorgulama zamanı',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Toplam  dosyalar',
        failure_parts: 'Arızalı parçalar',
        total_of_failure_parts: 'Toplam arızalı parçalar',
        of_organization: 'Organizasyon %',
        of_total: 'Toplam %',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        query_time: 'Čas dotazu',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Celkový počet případů',
        failure_parts: 'Poruchové díly',
        total_of_failure_parts: 'Celkový počet vadných dílů',
        of_organization: '% organizace',
        of_total: '% celkem',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        query_time: 'Lekérdezési idő',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Összes eset',
        failure_parts: 'Meghibásodott alkatrészek',
        total_of_failure_parts: 'Összes meghibásodott alkatrész',
        of_organization: 'Szervezet %-a',
        of_total: 'Összes %-a',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        query_time: 'Время запроса',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        failure_parts: 'Наименование неисправных деталей',
        total_of_failure_parts: 'Общее количество неисправных деталей',
        of_organization: 'Доля организации',
        of_total: 'Доля от общего числа',
    },
    // 沙特阿拉伯
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        query_time: 'وقت الاستعلام',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        failure_parts: 'اسم القطعة المعطلة',
        total_of_failure_parts: 'كمية القطع المعطلة',
        of_organization: 'نسبة المنظمة',
        of_total: 'نسبة الإجمالي',
    },
    // 保加利亚
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        query_time: 'Време на заявката',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        failure_parts: 'Име на повредената част',
        total_of_failure_parts: 'Брой повредени части',
        of_organization: 'Дял на организацията',
        of_total: 'Дял от общото количество',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        query_time: 'Forespørgselstidspunkt',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        failure_parts: 'Fejlbehæftet komponent',
        total_of_failure_parts: 'Antal fejlbehæftede komponenter',
        of_organization: 'Andel for organisationen',
        of_total: 'Andel af det samlede antal',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        query_time: 'Hakuaika',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        failure_parts: 'Viallinen osa',
        total_of_failure_parts: 'Viallisten osien määrä',
        of_organization: 'Organisaation osuus',
        of_total: 'Koko aineiston osuus',
    },
    // 繁体中文台湾
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        query_time: '查詢時間',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        failure_parts: '故障件名稱',
        total_of_failure_parts: '故障件數量',
        of_organization: '組織佔比',
        of_total: '全量佔比',
    },
    // 克罗地亚
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        query_time: 'Vrijeme upita',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        failure_parts: 'Naziv neispravnog dijela',
        total_of_failure_parts: 'Broj neispravnih dijelova',
        of_organization: 'Udio organizacije',
        of_total: 'Udio u ukupnom broju',
    },
    // 拉脱维亚
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        query_time: 'Vaicājuma laiks',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        failure_parts: 'Bojātās detaļas nosaukums',
        total_of_failure_parts: 'Bojāto detaļu skaits',
        of_organization: 'Organizācijas īpatsvars',
        of_total: 'Kopējā īpatsvars',
    },
    // 立陶宛
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        query_time: 'Užklausos laikas',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        failure_parts: 'Sugedusių detalių pavadinimas',
        total_of_failure_parts: 'Sugedusių detalių skaičius',
        of_organization: 'Organizacijos dalis',
        of_total: 'Bendrosios dalies procentas',
    },
    // 罗马尼亚
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        query_time: 'Timpul interogării',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        failure_parts: 'Denumirea piesei defecte',
        total_of_failure_parts: 'Numărul pieselor defecte',
        of_organization: 'Procent din organizație',
        of_total: 'Procent din total',
    },
    // 挪威博克马尔
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        query_time: 'Spørringstidspunkt',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        failure_parts: 'Feilaktig komponent',
        total_of_failure_parts: 'Antall feilaktige komponenter',
        of_organization: 'Andel for organisasjonen',
        of_total: 'Andel av totalen',
    },
    // 葡萄牙语巴西
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        query_time: 'Horário da consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        failure_parts: 'Nome da peça com falha',
        total_of_failure_parts: 'Quantidade de peças com falha',
        of_organization: 'Proporção da organização',
        of_total: 'Proporção do total',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        query_time: 'Förfråganstidpunkt',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        failure_parts: 'Felaktig komponent',
        total_of_failure_parts: 'Antal felaktiga komponenter',
        of_organization: 'Andel för organisationen',
        of_total: 'Andel av totalen',
    },
    // 斯洛伐克
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        query_time: 'Čas dopytu',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        failure_parts: 'Názov poruchovej súčasti',
        total_of_failure_parts: 'Počet poruchových súčastí',
        of_organization: 'Podiel organizácie',
        of_total: 'Podiel z celkového množstva',
    },
    // 斯洛文尼亚
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        query_time: 'Čas poizvedbe',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        failure_parts: 'Ime okvarjenega dela',
        total_of_failure_parts: 'Število okvarjenih delov',
        of_organization: 'Delež organizacije',
        of_total: 'Delež od skupnega števila',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        query_time: 'เวลาการสอบถาม',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        failure_parts: 'ชื่อชิ้นส่วนที่ชำรุด',
        total_of_failure_parts: 'จำนวนชิ้นส่วนที่ชำรุด',
        of_organization: 'สัดส่วนขององค์กร',
        of_total: 'สัดส่วนจากทั้งหมด',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        query_time: 'Час запиту',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        failure_parts: 'Назва несправної деталі',
        total_of_failure_parts: 'Кількість несправних деталей',
        of_organization: 'Частка організації',
        of_total: 'Частка від загальної кількості',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        query_time: 'Χρόνος ερωτήματος',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        failure_parts: 'Όνομα ελαττωματικού εξαρτήματος',
        total_of_failure_parts: 'Ποσότητα ελαττωματικών εξαρτημάτων',
        of_organization: 'Ποσοστό οργανισμού',
        of_total: 'Ποσοστό επί του συνόλου',
    },
    // 爱沙尼亚
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        query_time: 'Päringu aeg',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        failure_parts: 'Rikkeosa nimi',
        total_of_failure_parts: 'Rikkeosade arv',
        of_organization: 'Organisatsiooni osakaal',
        of_total: 'Koguosakaal',
    },
    // 哈萨克
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        query_time: 'Сұрау уақыты',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        failure_parts: 'Ақаулы бөлшектің атауы',
        total_of_failure_parts: 'Ақаулы бөлшектер саны',
        of_organization: 'Ұйымның үлесі',
        of_total: 'Жалпы үлес',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        query_time: 'זמן השאילתה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        failure_parts: 'שם הרכיב התקול',
        total_of_failure_parts: 'כמות הרכיבים התקולים',
        of_organization: 'אחוז מהארגון',
        of_total: 'אחוז מסך הכל',
    },
};
